import { render, staticRenderFns } from "./iconAddImage.vue?vue&type=template&id=668c52de"
import script from "./iconAddImage.vue?vue&type=script&lang=js"
export * from "./iconAddImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports